export function isStarterPricePlan(planType: PricePlanId | string | null | undefined): boolean {
  // TODO: Match against distinct price plan IDs
  return Boolean(planType?.startsWith('STARTER'))
}
